import type { Store } from '@/types'

export interface DeliveryAddressParams {
  street: string
  suburb: string
  postcode: string
  state: string
  latitude: number
  longitude: number
  formatted: string
  placeId?: string
  suburbId?: string
  areaCode?: string
  area?: string
}

export interface StoreRedirectOptions {
  store: Store & {
    minOrderValue?: string
    deliveryCost?: string
    suburbId?: string
  }
  fulfillmentMode: 'pickup' | 'delivery'
  deliveryAddress?: DeliveryAddressParams | null
}

export function buildStoreRedirectUrl({
  store,
  fulfillmentMode,
  deliveryAddress,
}: StoreRedirectOptions): string | null {
  const baseUrl = store.redirectUrl || store.baseUrl

  if (!baseUrl) {
    console.error('No base URL configured for store:', store.name)
    return null
  }

  const url = new URL(baseUrl)

  if (fulfillmentMode === 'delivery' && deliveryAddress) {
    url.searchParams.set('type', 'delivery')
    url.searchParams.set('address', deliveryAddress.formatted)
    url.searchParams.set('lat', deliveryAddress.latitude.toString())
    url.searchParams.set('lng', deliveryAddress.longitude.toString())
    
    if (deliveryAddress.placeId) {
      url.searchParams.set('placeId', deliveryAddress.placeId)
    }
    
    const suburbId = store.suburbId || deliveryAddress.suburbId || ''
    url.searchParams.set('suburbId', suburbId)
    
    const deliveryCost = store.deliveryCost || '0.00'
    url.searchParams.set('deliveryCost', deliveryCost)
    
    const minOrderValue = store.minOrderValue || '0.00'
    url.searchParams.set('minOrderValue', minOrderValue)
    
    const areaCode = deliveryAddress.areaCode || deliveryAddress.postcode || ''
    url.searchParams.set('areaCode', areaCode)
    
    const area = deliveryAddress.area || ''
    url.searchParams.set('area', area)
  } else {
    url.searchParams.set('type', 'pickup')
  }

  return url.toString()
}

export function redirectToStore(options: StoreRedirectOptions): void {
  const url = buildStoreRedirectUrl(options)

  if (url) {
    window.open(url, '_blank')
  }
}
